import React from 'react';
import {EdapProvider} from '@homeaway/react-event-tracking';
import FilterBar from '../FilterBar/FilterBar';
import FilterForm from '../FilterForm/FilterForm';
import {IntlProvider} from 'react-intl';
import {formatLocale} from '../../utils/localization';
import Experiment, {
    ExperimentProvider,
    On,
    Off,
} from '@homeaway/react-experiment';
import {VRBO_WEB_SEARCH_NEW_FILTER_MENU} from '../../abacus/experiments';
import {FILTER__16, CARET_DOWN__16} from '@homeaway/svg-defs';
import FilterBarV2 from '../FilterBarV2/FilterBarV2';
import FilterPill from '../FilterPill/FilterPill';

function FiltersContainer(props) {
    const eventcategory = {eventcategory: 'search'};
    const intlLocale = formatLocale(props.locale);
    const abacus = props.abacus;

    return (
        <IntlProvider locale={intlLocale} messages={props.messages}>
            <ExperimentProvider abacus={abacus}>
                <EdapProvider fields={eventcategory}>
                    <Experiment name={VRBO_WEB_SEARCH_NEW_FILTER_MENU}>
                        <On>
                            <FilterBarV2>
                                <FilterPill icon={FILTER__16} />
                                <FilterPill
                                    label={'Price'}
                                    icon={CARET_DOWN__16}
                                />
                                <FilterPill
                                    label={'Bedrooms'}
                                    icon={CARET_DOWN__16}
                                />
                                <FilterPill
                                    label={'Instant Confirmation'}
                                    icon={CARET_DOWN__16}
                                />
                                <FilterPill
                                    label={'More Filters'}
                                    icon={FILTER__16}
                                    leftAlign
                                    applied
                                />
                            </FilterBarV2>
                        </On>
                        <Off>
                            {props.isMobile ? (
                                <FilterForm {...props} />
                            ) : (
                                <FilterBar {...props} />
                            )}
                        </Off>
                    </Experiment>
                </EdapProvider>
            </ExperimentProvider>
        </IntlProvider>
    );
}

export default FiltersContainer;
export {FiltersContainer as Filters};
